<template>
  <div class="zoox-component zoox-speed-dial">
    <!--Evento emitido ao abrir e fechar o `speed-dial`
        @event change
        @property {Boolean} value - Se o `speed-dial` está aberto ou fechado
     -->
    <v-speed-dial
      :absolute="absolute"
      :bottom="bottom"
      :right="right"
      :left="left"
      :top="top"
      :value="value"
      :direction="direction"
      @input="$emit('change', $event)"
    >
      <template #activator>
        <v-btn
          v-model="value"
          class="speed-dial-btn"
          dark
          elevation="1"
          fab
          color="white"
          :style="{'--z-speed-dial-color': color}"
        >
          <z-icon>{{ icon }}</z-icon>
        </v-btn>
      </template>
      <!--Evento emetido ao clicar em uma das opções
          @event click
          @property {Object} action - Objeto referente á opção clicada
       -->
      <v-btn
        v-for="(action, index) in actionBtns"
        :key="index"
        ref="action-btn"
        fab
        dark
        small
        :elevation="action.elevation || 0"
        :color="action.color"
        @click="$emit('click', action)"
      >
        <z-icon :color="action.iconColor">{{ action.icon }}</z-icon>
      </v-btn>
    </v-speed-dial>
    <v-overlay v-if="hasOverlay" absolute :value="value"></v-overlay>
  </div>
</template>

<script>
/**
 * @displayName Speed Dial
 */
export default {
  name: 'ZSpeedDial',
  model: {
    prop: 'value',
    event: 'change',
  },
  props: {
    /**
     * Define se o speed dial está aberto ou fechado (model)
     *
     * @modelName value
     */
    value: {
      type: Boolean,
      default: false,
    },
    /**
     * Define o ícone do speed dial
     */
    icon: {
      type: String,
      default: '$filter_list_rounded',
    },

    /**
     * Define a direção que o conteúdo do speed dial vai aparecer
     *
     * @typedef  {left| right | top | bottom}
     */
    direction: {
      type: String,
      default: 'top',
    },

    /**
     * Define a cor do speed dial
     */
    color: {
      type: String,
      default: 'purple',
    },
    /**
     * Aplica position:absolute no componente
     */
    absolute: {
      type: Boolean,
      default: false,
    },
    /**
     * Flag para indicar se o speed dial aplicará um overlay ao componente pai
     */
    hasOverlay: {
      type: Boolean,
      default: false,
    },
    /**
     * Array de ações para mostrar no speed dial
     *
     * @typedef {Object}  {icon: string, color: string, iconColor: string}
     */
    actionBtns: {
      type: Array,
      default: () => [],
    },
    /**
     * Posiciona o speed dial no final do componente pai
     */
    bottom: {
      type: Boolean,
    },
    /**
     * Posiciona o speed dial no topo do componente pai
     */
    top: {
      type: Boolean,
    },
    /**
     * Posiciona o speed dial na esquerda do componente pai
     */
    left: {
      type: Boolean,
    },
    /**
     * Posiciona o speed dial na direita do componente pai
     */
    right: {
      type: Boolean,
    },
  },
}
</script>

<style lang="scss" scoped>
.zoox-speed-dial {
  .v-overlay {
    z-index: unset !important;

    .speed-dial-btn {
      background: var(--white) !important;
    }
  }
}
</style>

<style lang="scss">
.speed-dial-btn {
  .v-btn__content {
    background-color: var(--z-speed-dial-color) !important;
    width: 40px !important;
    height: 40px !important;
    border-radius: 50% !important;
    flex: unset; /* remove default flex */
  }
}
</style>
